
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import SalesCatalystAttitudeComparisionDetail from './SalesCatalystAttitudeComparisionDetail';
import SalesCatalystDemoComparisionDetail from './SalesCatalystDemoComparisionDetail';
import {
  TARGET_MARKET_HEADING,
  WEIGHTED_LABEL,
  REACH_LABEL,
  SAMPLE_LABEL,
  LENGHT_OF_TARGET_MARKET_HEADER_LABEL,
} from '../../../constants';
import { numberWithCommas, nthOccurrence } from '../../../util/CommonUtils';
import * as salesCatalystActions from '../../../actions/salesCatalystActions';
import scWeebleImage from '../../../images/SC-weeble_default.png';
import SalesCatalystSectionBottom from '../SalesCatalystSectionBottom';


class TargetMarketAttitude extends Component {
  constructor(props) {
    super(props);

    this.state = {
      scAttitudesDisplayList: [],
      scDemoDisplayList: [],
      displayGroups: [],
    };
  }


  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.scAttitudesDisplayList !== nextProps.scAttitudesDisplayList) {
      this.setState({ scAttitudesDisplayList: nextProps.scAttitudesDisplayList });
    }
    if (this.props.scDemoDisplayList !== nextProps.scDemoDisplayList) {
      this.setState({ scDemoDisplayList: nextProps.scDemoDisplayList });
      if (nextProps.scDemoDisplayList[0] !== undefined) {
        this.setState({
          displayGroups: nextProps.scDemoDisplayList[0].detailGroups,
        });
      }
    }
  }


  getIndexOfTargetHeader = label => {
    let lenghtOfLabel = LENGHT_OF_TARGET_MARKET_HEADER_LABEL;
    const nthOccurrenceIndexOfEntity = nthOccurrence(label, ')', 1);
    if (
      nthOccurrenceIndexOfEntity < lenghtOfLabel &&
      nthOccurrenceIndexOfEntity !== -1 &&
      nthOccurrenceIndexOfEntity !== 'undefined'
    ) {
      lenghtOfLabel = nthOccurrenceIndexOfEntity + 1;
    }
    return lenghtOfLabel;
  };


  render() {
    return (
      <div className="large-12 medium-12 small-12">

        <div className="row fullWidth" id="salesLandingBlockSection">
          <div className="large-12 medium-12 small-12 columns imageBlock-header">
            {((this.props.targetMarketFlag === true) &&
              (this.props.entity.length > 0 && this.props.targetMarket.length > 0) &&
              (this.props.scAttitudesDisplayList.length !== 0 &&
                this.props.scDemoDisplayList.length !== 0)) &&

              <div className="targetMarketDefaultHeader"
                title={`${this.props.targetMarket[0].label} AND ${this.props.entity[0].label}`}
              >
               {this.props.targetMarket[0].label.substring(
                  0,
                  this.getIndexOfTargetHeader(this.props.targetMarket[0].label)
                )} AND {this.props.entity[0].label.substring(
                  0,
                  this.getIndexOfTargetHeader(this.props.entity[0].label),
                )}
              </div>
            }

            {((this.props.targetMarketFlag !== true) ||
              (this.props.scAttitudesDisplayList.length === 0 &&
                this.props.scDemoDisplayList.length === 0)) &&
              <div className="targetMarketDefaultHeader">{TARGET_MARKET_HEADING}
              </div>
            }
          </div>
          {((this.props.targetMarketFlag === true) &&
              (this.props.scAttitudesDisplayList.length !== 0 &&
                this.props.scDemoDisplayList.length !== 0)) &&
          <div className="large-12 medium-12 small-12 columns imageBlock-labels">
            <div className="large-2 medium-2 small-2 columns">
              {this.props.targetEntityOverlap !== undefined && !_.isEmpty(this.props.targetEntityOverlap) &&
                <div>
                  <span className="sc-weight-reach-comparision-info">{SAMPLE_LABEL}:</span>
                  <span className="weight-reach-comparision-data"> {numberWithCommas(Math.round(this.props.targetEntityOverlap.sample))} </span>
                </div>
              }
            </div>
            <div className="large-3 medium-3 small-3 columns ">
              {this.props.targetEntityOverlap !== undefined && !_.isEmpty(this.props.targetEntityOverlap) &&
                <div>
                  <span className="sc-weight-reach-comparision-info">{WEIGHTED_LABEL}: </span>
                  <span className="weight-reach-comparision-data"> {numberWithCommas(Math.round(this.props.targetEntityOverlap.weighted))}</span>

                </div>
              }
            </div>
            <div className="large-2 medium-2 small-2 columns">
              {this.props.targetEntityOverlap !== undefined && !_.isEmpty(this.props.targetEntityOverlap) &&
                <div>
                  <span className="sc-weight-reach-comparision-info">{REACH_LABEL}: </span>
                  <span className="weight-reach-comparision-data">{Math.round(this.props.targetEntityOverlap.pct * 10) / 10}% </span> </div>
              }
            </div>
            <div className="large-5 medium-5 small-5 columns">&nbsp;</div>
          </div>
          }
          <div className="row fullWidth">
            <div className="large-4 medium-4 small-4 columns">&nbsp;
              {((this.props.scAttitudesDisplayList.length !== 0 && this.props.scDemoDisplayList.length !== 0) && (this.props.targetMarketFlag === true)) &&
                <div className="row">
                  <div className="sc-demo-heading">Demographics</div>
                  {!_.isEmpty(this.props.scDemoDisplayList[0].detailGroups) &&
                    this.props.scDemoDisplayList[0].detailGroups.length > 0 &&
                    this.props.scDemoDisplayList[0].detailGroups.map((demoDetail, index) => (
                      <div key={index}>
                        <div className="columns large-12 medium-12 small-12">
                          <div
                            className="row fullwidth demographic-detail-columns"
                            key={`demo-d${index}}`}
                          >
                            <div
                              className="columns large-12 small-12 medium-12"
                            >
                              {
                                <SalesCatalystDemoComparisionDetail
                                  key={demoDetail.name}
                                  demoDetail={demoDetail}
                                />
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              }
            </div>

            <div className="large-4 medium-4 small-4 columns imageBlock">
              <span>
                <img
                  alt="Up Arrow"
                  className="imageBlockSpan"
                  src={scWeebleImage}
                />
              </span>
            </div>

            <div
              className="large-4 medium-4 small-4 columns"
            >&nbsp;
              {((this.props.scAttitudesDisplayList.length !== 0 && this.props.scDemoDisplayList.length !== 0)
               && (this.props.targetMarketFlag === true)) &&
                <div className="row">
                  <div className="sc-attitude-heading">ATTITUDES</div>
                  {!_.isEmpty(this.props.scAttitudesDisplayList) &&
                    this.props.scAttitudesDisplayList.length !== 0 &&
                    this.props.scAttitudesDisplayList.map((item, index) => (

                      <SalesCatalystAttitudeComparisionDetail scAttitudeObj={item} />
                    ))
                  }
                </div>
              }
            </div>
          </div>
          <div className="padding-10">
            <SalesCatalystSectionBottom />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    scAttitudesDisplayList: state.salesCatalyst.scAttitudesDisplayList,
    scDemoDisplayList: state.salesCatalyst.scDemoDisplayList,
    targetEntityOverlap: state.salesCatalyst.dataSelection.targetEntityOverlap,
    entity: state.salesCatalyst.dataSelection.entity,
    targetMarket: state.salesCatalyst.dataSelection.targetMarket,
    targetMarketFlag: state.salesCatalyst.dataOnScreen.targetMarket,
  };
}


function mapDispatchToProps(dispatch) {
  return {
    salesCatalystActions: bindActionCreators(salesCatalystActions, dispatch),
  };
}


export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TargetMarketAttitude);

